export const termsAndConditionsUrl = 'https://ez-eats.com/termsandconditions/';
export const privacypolicyUrl = 'https://ez-eats.com/privacypolicy/';

